type SubFeature ={
  path: string;
  enabled: boolean;
}

type Permission ={
  subFeatures: SubFeature[];
}


/**
 * Checks if the given path has access based on the provided permissions.
 *
 * @param path - The path to check access for.
 * @param permissions - An array of permissions to check against.
 * @returns `true` if access to the path is granted, otherwise `false`.
 */
export const hasAccessToPath = (
  path: string,
  permissions: Permission[]
): boolean => {
  for (const permission of permissions) {
    for (const subFeature of permission.subFeatures) {
      // Verifica se o caminho atual começa com o caminho da subFeature e se está habilitado
      if (path.startsWith(subFeature.path) && subFeature.enabled) {
        return true;
      }
    }
  }
  return false;
};
